<!-- 招投标项目的添加 / 编辑表单弹窗 -->
<template>
  <Dialog v-model="dialogVisible" :title="dialogTitle" width="70%">
    <el-form
      ref="formRef"
      v-loading="formLoading"
      :model="formData"
      :rules="formRules"
      label-width="110px"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="甲方名称" prop="customerId">
            <el-select
              v-model="formData.customerId"
              class="w-1/1"
              filterable
              placeholder="请选择甲方"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model="formData.projectName" placeholder="请输入项目名称" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="对应产品" prop="productId">
            <el-select
              v-model="formData.productId"
              class="w-1/1"
              clearable
              filterable
              placeholder="请选择产品"
            >
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开发语言" prop="devLanguage">
            <el-select
              v-model="formData.devLanguage"
              class="w-1/1"
              clearable
              placeholder="请选择开发语言"
            >
              <el-option
                v-for="dict in getIntDictOptions(DICT_TYPE.CRM_BID_DEV_LANGUAGE)"
                :key="dict.value"
                :label="dict.label"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目编号" prop="projectNo">
            <el-input v-model="formData.projectNo" placeholder="请输入项目编号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="获标时间" prop="winTime">
            <el-date-picker
              v-model="formData.winTime"
              class="w-1/1"
              placeholder="请选择获标时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="获标截止时间" prop="winDeadline">
            <el-date-picker
              v-model="formData.winDeadline"
              class="w-1/1"
              placeholder="请选择获标截止时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="投标截止时间" prop="bidDeadline">
            <el-date-picker
              v-model="formData.bidDeadline"
              class="w-1/1"
              placeholder="请选择投标截止时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="述标时间" prop="presentTime">
            <el-date-picker
              v-model="formData.presentTime"
              class="w-1/1"
              placeholder="请选择述标时间"
              type="datetime"
              value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="达标要求" prop="reachRequirement">
            <el-input
              v-model="formData.reachRequirement"
              :rows="3"
              placeholder="请输入达标要求"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="达标地点" prop="reachPlace">
            <el-input v-model="formData.reachPlace" placeholder="请输入达标地点" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="标书费用" prop="bookFee">
            <el-input-number
              v-model="formData.bookFee"
              :min="0"
              :precision="2"
              class="w-1/1"
              controls-position="right"
              placeholder="请输入标书费用"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目预算" prop="projectBudget">
            <el-input-number
              v-model="formData.projectBudget"
              :min="0"
              :precision="2"
              class="w-1/1"
              controls-position="right"
              placeholder="请输入项目预算"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="项目周期" prop="projectCycle">
            <el-input v-model="formData.projectCycle" placeholder="请输入项目周期，如 3 个月" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="保证金" prop="deposit">
            <el-input-number
              v-model="formData.deposit"
              :min="0"
              :precision="2"
              class="w-1/1"
              controls-position="right"
              placeholder="请输入保证金"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="项目状态" prop="projectStatus">
            <el-input
              v-model="formData.projectStatus"
              :rows="3"
              placeholder="请输入项目状态"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formData.remark"
              :rows="2"
              placeholder="请输入备注"
              type="textarea"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button :disabled="formLoading" type="primary" @click="submitForm">保 存</el-button>
      <el-button @click="dialogVisible = false">取 消</el-button>
    </template>
  </Dialog>
</template>

<script lang="ts" setup>
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict'
import { BidProjectApi } from '@/api/crm/bidProject'
import * as CustomerApi from '@/api/crm/customer'
import * as ProductApi from '@/api/crm/product'

defineOptions({ name: 'BidProjectForm' })

const { t } = useI18n() // 国际化
const message = useMessage() // 消息弹窗

const dialogVisible = ref(false) // 弹窗的是否展示
const dialogTitle = ref('') // 弹窗的标题
const formLoading = ref(false) // 表单的加载中
const formType = ref('') // 表单的类型：create - 新增；update - 修改
const customerList = ref<any[]>([]) // 客户（甲方）下拉
const productList = ref<any[]>([]) // 产品下拉

/** 空表单数据 */
const emptyFormData = () => ({
  id: undefined,
  customerId: undefined,
  projectName: undefined,
  productId: undefined,
  devLanguage: undefined,
  projectNo: undefined,
  winTime: undefined,
  winDeadline: undefined,
  bidDeadline: undefined,
  presentTime: undefined,
  reachRequirement: undefined,
  reachPlace: undefined,
  bookFee: undefined,
  projectBudget: undefined,
  projectCycle: undefined,
  deposit: undefined,
  projectStatus: undefined,
  remark: undefined
})

const formData = ref<any>(emptyFormData())
const formRules = reactive({
  customerId: [{ required: true, message: '甲方名称不能为空', trigger: 'change' }],
  projectName: [{ required: true, message: '项目名称不能为空', trigger: 'blur' }],
  winTime: [{ required: true, message: '获标时间不能为空', trigger: 'change' }],
  winDeadline: [{ required: true, message: '获标截止时间不能为空', trigger: 'change' }],
  bidDeadline: [{ required: true, message: '投标截止时间不能为空', trigger: 'change' }],
  presentTime: [{ required: true, message: '述标时间不能为空', trigger: 'change' }]
})
const formRef = ref() // 表单 Ref

/** 打开弹窗 */
const open = async (type: string, id?: number) => {
  dialogVisible.value = true
  dialogTitle.value = type === 'create' ? '新增招投标项目汇总' : '编辑招投标项目汇总'
  formType.value = type
  resetForm()
  // 加载下拉数据
  customerList.value = await CustomerApi.getCustomerSimpleList()
  productList.value = await ProductApi.getProductSimpleList()
  // 修改时，加载数据
  if (id) {
    formLoading.value = true
    try {
      const data = await BidProjectApi.getBidProject(id)
      formData.value = {
        id: data.id,
        customerId: data.customerId,
        projectName: data.projectName,
        productId: data.productId,
        devLanguage: data.devLanguage,
        projectNo: data.projectNo,
        winTime: data.winTime,
        winDeadline: data.winDeadline,
        bidDeadline: data.bidDeadline,
        presentTime: data.presentTime,
        reachRequirement: data.reachRequirement,
        reachPlace: data.reachPlace,
        bookFee: data.bookFee,
        projectBudget: data.projectBudget,
        projectCycle: data.projectCycle,
        deposit: data.deposit,
        projectStatus: data.projectStatus,
        remark: data.remark
      }
    } finally {
      formLoading.value = false
    }
  }
}
defineExpose({ open }) // 提供 open 方法，用于打开弹窗

/** 提交表单 */
const emit = defineEmits(['success']) // 定义 success 事件，用于操作成功后的回调
const submitForm = async () => {
  // 校验表单
  await formRef.value.validate()
  // 提交请求
  formLoading.value = true
  try {
    const data = { ...formData.value }
    if (formType.value === 'create') {
      await BidProjectApi.createBidProject(data)
      message.success(t('common.createSuccess'))
    } else {
      await BidProjectApi.updateBidProject(data)
      message.success(t('common.updateSuccess'))
    }
    dialogVisible.value = false
    // 发送操作成功的事件
    emit('success')
  } finally {
    formLoading.value = false
  }
}

/** 重置表单 */
const resetForm = () => {
  formData.value = emptyFormData()
  formRef.value?.resetFields()
}
</script>
